import { __assign } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import styles from './index.module.scss.js';

var AppIconImage = function (_a) {
    var alt = _a.alt, customAppIcon = _a.customAppIcon, appIcon = _a.appIcon, assetEndpoint = _a.assetEndpoint;
    var icon = appIcon || "".concat(assetEndpoint, "/assets/images/icons/ces.svg");
    return (jsx("div", __assign({ className: styles.appIconImage }, { children: jsx("img", { src: customAppIcon || icon, alt: alt }, void 0) }), void 0));
};

export { AppIconImage as default };
